import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Machine, CustomerInfo, CustomerGroupWithMembers, GenericResponse_$reflection, Machine_$reflection, CustomerGroupWithMembers_$reflection, CustomerGroup_$reflection, CustomerInfo_$reflection } from "./Shared/ApiDataTypes.js";
import { obj_type, record_type, bool_type, union_type, string_type, array_type, int32_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { corsProps, testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { isEmpty, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { value as value_5, some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { numberHash, comparePrimitives, int32ToString, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { API_Machine_favorite, API_Customer_favorite, API_CustomerGroup_Favorite } from "./Shared/Urls.js";
import { RouterModule_nav, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { contains, map as map_1, singleton, append, sortBy, tryHead, partition } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Cmd_OfFunc_perform, Cmd_none, Cmd_OfPromise_perform } from "./fable_modules/Fable.Elmish.4.0.0/cmd.fs.js";
import { createDisposable, createContext } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import React from "react";
import * as react from "react";
import { React_useElmish_Z6C327F2E } from "./fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "./fable_modules/Fable.Elmish.4.0.0/program.fs.js";
import { useEffectWithDeps } from "./fable_modules/Feliz.2.8.0/ReactInterop.js";
import { singleton as singleton_1, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { CircularProgress, Backdrop } from "@mui/material";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";

export class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddCustomer", "AddGroup", "FavoriteCustomer", "FavoriteGroup", "FavoriteMachine", "RemoveFavoriteCustomer", "RemoveFavoriteGroup", "RemoveFavoriteMachine", "SetGroups", "SetSearchTerm", "UpdateCustomer", "UpdateGroup", "Ignore"];
    }
}

export function Message_$reflection() {
    return union_type("Kundeweb.CompanyHierarchyContext.Message", [], Message, () => [[["Item", CustomerInfo_$reflection()]], [["Item", CustomerGroup_$reflection()]], [["groupId", int32_type], ["Item2", CustomerInfo_$reflection()]], [["Item", CustomerGroupWithMembers_$reflection()]], [["groupId", int32_type], ["customerId", int32_type], ["Item3", Machine_$reflection()]], [["groupId", int32_type], ["Item2", CustomerInfo_$reflection()]], [["Item", CustomerGroupWithMembers_$reflection()]], [["groupId", int32_type], ["customerId", int32_type], ["Item3", Machine_$reflection()]], [["Item", array_type(CustomerGroupWithMembers_$reflection())]], [["Item", string_type]], [["Item", CustomerInfo_$reflection()]], [["Item", CustomerGroup_$reflection()]], []]);
}

export class Model extends Record {
    constructor(SearchTerm, GroupsFetched, Groups) {
        super();
        this.SearchTerm = SearchTerm;
        this.GroupsFetched = GroupsFetched;
        this.Groups = Groups;
    }
}

export function Model_$reflection() {
    return record_type("Kundeweb.CompanyHierarchyContext.Model", [], Model, () => [["SearchTerm", string_type], ["GroupsFetched", bool_type], ["Groups", array_type(CustomerGroupWithMembers_$reflection())]]);
}

export function Model_get_Empty() {
    return new Model("", false, []);
}

function fetchGroups() {
    let properties_2;
    let pr_2;
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(CustomerGroupWithMembers_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/customer-group/user-groups", properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(CustomerGroupWithMembers_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
    return pr_2.then((res) => {
        if (res.tag === 1) {
            console.error(some("Error fetching customer groups"), res.fields[0]);
            return [];
        }
        else {
            const groups = res.fields[0];
            console.debug("Got groups with members:", groups);
            return groups;
        }
    });
}

function deleteFavoriteCustomerGroup(id) {
    let properties_2;
    const url = API_CustomerGroup_Favorite(id);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Successfully deleted customer group from favorites"), res.fields[0]);
        }
        else {
            console.error(some("Error deleting customer group favorite entry:"), res.fields[0]);
        }
    });
}

function deleteFavoriteCustomer(groupId, id) {
    let properties_2;
    const url = API_Customer_favorite(id) + (`?group=${groupId}`);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Successfully deleted customer from favorites"), res.fields[0]);
        }
        else {
            console.error(some("Error deleting customer favorite entry:"), res.fields[0]);
        }
    });
}

function deleteFavoriteMachine(groupId, customerId, id) {
    let properties_2;
    const url = API_Machine_favorite(id) + (`?group=${groupId}&customer=${customerId}`);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Got back from deleting fav machine"), res.fields[0]);
        }
        else {
            console.error(some("Error deleting favorite machine:"), res.fields[0]);
        }
    });
}

function postFavoriteCustomerGroup(id) {
    let properties_2;
    const url = API_CustomerGroup_Favorite(id);
    let pr_1;
    const body = Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)("");
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Got back from fav group"), res.fields[0]);
        }
        else {
            console.error(some("Error favoriting customer group:"), res.fields[0]);
        }
    });
}

function postFavoriteCustomer(groupId, id) {
    let properties_2;
    const url = API_Customer_favorite(id) + (`?group=${groupId}`);
    let pr_1;
    const body = Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)("");
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Got back from fav customer"), res.fields[0]);
        }
        else {
            console.error(some("Error favoriting customer:"), res.fields[0]);
        }
    });
}

function postFavoriteMachine(groupId, customerId, id) {
    let properties_2;
    const url = API_Machine_favorite(id) + (`?group=${groupId}&customer=${customerId}`);
    let pr_1;
    const body = Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)("");
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = some(body);
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((res) => {
        if (res.tag === 0) {
            console.info(some("Got back from fav machine"), res.fields[0]);
        }
        else {
            console.error(some("Error favoriting machine:"), res.fields[0]);
        }
    });
}

function gotoFirstGroup(groups) {
    if (isEmpty(RouterModule_urlSegments(window.location.hash, 1))) {
        const patternInput = partition((_arg) => _arg.Favorite, groups);
        const favorites = patternInput[0];
        const firstOpt = tryHead((favorites.length === 0) ? patternInput[1] : favorites);
        if (firstOpt != null) {
            const group = value_5(firstOpt);
            console.info(some("Going to first group again: %d"), group.Id);
            RouterModule_nav(ofArray(["group", int32ToString(group.Id)]), 1, 1);
        }
        else {
            console.warn(some("You have no customer groups registered"));
        }
    }
}

function updateGroup(id, f, group) {
    if (group.Id === id) {
        return f(group);
    }
    else {
        return group;
    }
}

function updateCustomer(id, f, customer) {
    if (customer.Id === id) {
        return f(customer);
    }
    else {
        return customer;
    }
}

function updateMachine(id, f, machine) {
    if (machine.Id === id) {
        return f(machine);
    }
    else {
        return machine;
    }
}

function init() {
    return [Model_get_Empty(), Cmd_OfPromise_perform(fetchGroups, undefined, (Item) => (new Message(8, [Item])))];
}

function groupWithMembers(group) {
    return new CustomerGroupWithMembers(group.Id, group.Name, group.Enabled, group.IsMain, group.IsPtg, false, group.Company, []);
}

function update(msg, model) {
    switch (msg.tag) {
        case 1:
            return [new Model(model.SearchTerm, model.GroupsFetched, sortBy((_arg_1) => _arg_1.Name, append(model.Groups, singleton(groupWithMembers(msg.fields[0]))), {
                Compare: comparePrimitives,
            })), Cmd_none()];
        case 2: {
            const toFav = msg.fields[1];
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_1) => (new CustomerGroupWithMembers(group_1.Id, group_1.Name, group_1.Enabled, group_1.IsMain, group_1.IsPtg, group_1.Favorite, group_1.Company, map_1((customer) => {
                if (customer.Id === toFav.Id) {
                    return new CustomerInfo(customer.Id, customer.Number, customer.Name, customer.Enabled, customer.EnableServices, customer.EnableExtra, customer.HasAgreement, true, customer.Memo, customer.Responsible, customer.ServiceLead, customer.Machines, customer.MarketCategories, customer.Groups);
                }
                else {
                    return customer;
                }
            }, group_1.Customers))), model.Groups)), Cmd_OfPromise_perform((tupledArg) => postFavoriteCustomer(tupledArg[0], tupledArg[1]), [msg.fields[0], toFav.Id], () => (new Message(12, [])))];
        }
        case 4: {
            const toFav_1 = msg.fields[2];
            const groupId_2 = msg.fields[0] | 0;
            const customerId = msg.fields[1] | 0;
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_3) => updateGroup(groupId_2, (group_2) => (new CustomerGroupWithMembers(group_2.Id, group_2.Name, group_2.Enabled, group_2.IsMain, group_2.IsPtg, group_2.Favorite, group_2.Company, map_1((customer_2) => updateCustomer(customerId, (customer_1) => (new CustomerInfo(customer_1.Id, customer_1.Number, customer_1.Name, customer_1.Enabled, customer_1.EnableServices, customer_1.EnableExtra, customer_1.HasAgreement, customer_1.Favorite, customer_1.Memo, customer_1.Responsible, customer_1.ServiceLead, map_1((machine_1) => updateMachine(toFav_1.Id, (machine) => (new Machine(machine.Id, machine.Code, machine.Name, machine.SerialNumber, machine.Type, true, machine.SubGroup, machine.WarrantyExpiry, machine.Removed)), machine_1), customer_1.Machines), customer_1.MarketCategories, customer_1.Groups)), customer_2), group_2.Customers))), group_3), model.Groups)), Cmd_OfPromise_perform((tupledArg_1) => postFavoriteMachine(tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]), [groupId_2, customerId, toFav_1.Id], () => (new Message(12, [])))];
        }
        case 3: {
            const toFav_2 = msg.fields[0];
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_5) => updateGroup(toFav_2.Id, (group_4) => (new CustomerGroupWithMembers(group_4.Id, group_4.Name, group_4.Enabled, group_4.IsMain, group_4.IsPtg, true, group_4.Company, group_4.Customers)), group_5), model.Groups)), Cmd_OfPromise_perform(postFavoriteCustomerGroup, toFav_2.Id, () => (new Message(12, [])))];
        }
        case 5: {
            const toRemove = msg.fields[1];
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_6) => (new CustomerGroupWithMembers(group_6.Id, group_6.Name, group_6.Enabled, group_6.IsMain, group_6.IsPtg, group_6.Favorite, group_6.Company, map_1((customer_4) => updateCustomer(toRemove.Id, (customer_3) => (new CustomerInfo(customer_3.Id, customer_3.Number, customer_3.Name, customer_3.Enabled, customer_3.EnableServices, customer_3.EnableExtra, customer_3.HasAgreement, false, customer_3.Memo, customer_3.Responsible, customer_3.ServiceLead, customer_3.Machines, customer_3.MarketCategories, customer_3.Groups)), customer_4), group_6.Customers))), model.Groups)), Cmd_OfPromise_perform((tupledArg_2) => deleteFavoriteCustomer(tupledArg_2[0], tupledArg_2[1]), [msg.fields[0], toRemove.Id], () => (new Message(12, [])))];
        }
        case 6: {
            const toRemove_1 = msg.fields[0];
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_8) => updateGroup(toRemove_1.Id, (group_7) => (new CustomerGroupWithMembers(group_7.Id, group_7.Name, group_7.Enabled, group_7.IsMain, group_7.IsPtg, false, group_7.Company, group_7.Customers)), group_8), model.Groups)), Cmd_OfPromise_perform(deleteFavoriteCustomerGroup, toRemove_1.Id, () => (new Message(12, [])))];
        }
        case 7: {
            const machine_2 = msg.fields[2];
            const groupId_6 = msg.fields[0] | 0;
            const customerId_2 = msg.fields[1] | 0;
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_10) => updateGroup(groupId_6, (group_9) => (new CustomerGroupWithMembers(group_9.Id, group_9.Name, group_9.Enabled, group_9.IsMain, group_9.IsPtg, group_9.Favorite, group_9.Company, map_1((customer_6) => updateCustomer(customerId_2, (customer_5) => (new CustomerInfo(customer_5.Id, customer_5.Number, customer_5.Name, customer_5.Enabled, customer_5.EnableServices, customer_5.EnableExtra, customer_5.HasAgreement, customer_5.Favorite, customer_5.Memo, customer_5.Responsible, customer_5.ServiceLead, map_1((machine_4) => updateMachine(machine_2.Id, (machine_3) => (new Machine(machine_3.Id, machine_3.Code, machine_3.Name, machine_3.SerialNumber, machine_3.Type, false, machine_3.SubGroup, machine_3.WarrantyExpiry, machine_3.Removed)), machine_4), customer_5.Machines), customer_5.MarketCategories, customer_5.Groups)), customer_6), group_9.Customers))), group_10), model.Groups)), Cmd_OfPromise_perform((tupledArg_3) => deleteFavoriteMachine(tupledArg_3[0], tupledArg_3[1], tupledArg_3[2]), [groupId_6, customerId_2, machine_2.Id], () => (new Message(12, [])))];
        }
        case 8: {
            const sorted = sortBy((_arg_2) => _arg_2.Name, msg.fields[0], {
                Compare: comparePrimitives,
            });
            return [new Model(model.SearchTerm, true, sorted), Cmd_OfFunc_perform((groups_5) => {
                gotoFirstGroup(groups_5);
            }, sorted, () => (new Message(12, [])))];
        }
        case 9:
            return [new Model(msg.fields[0], model.GroupsFetched, model.Groups), Cmd_none()];
        case 10: {
            const updatedCustomer = msg.fields[0];
            const updatedGroupIds = map_1((_arg_3) => _arg_3.Id, updatedCustomer.Groups, Int32Array);
            return [new Model(model.SearchTerm, model.GroupsFetched, map_1((group_11) => {
                if (!contains(group_11.Id, updatedGroupIds, {
                    Equals: (x_3, y_3) => (x_3 === y_3),
                    GetHashCode: numberHash,
                })) {
                    if (group_11.Customers.some((customer_7) => (customer_7.Id === updatedCustomer.Id))) {
                        return new CustomerGroupWithMembers(group_11.Id, group_11.Name, group_11.Enabled, group_11.IsMain, group_11.IsPtg, group_11.Favorite, group_11.Company, group_11.Customers.filter((customer_8) => (customer_8.Id !== updatedCustomer.Id)));
                    }
                    else {
                        return group_11;
                    }
                }
                else {
                    return new CustomerGroupWithMembers(group_11.Id, group_11.Name, group_11.Enabled, group_11.IsMain, group_11.IsPtg, group_11.Favorite, group_11.Company, group_11.Customers.some((customer_9) => (customer_9.Id === updatedCustomer.Id)) ? map_1((customer_10) => {
                        if (customer_10.Id === updatedCustomer.Id) {
                            return updatedCustomer;
                        }
                        else {
                            return customer_10;
                        }
                    }, group_11.Customers) : append(group_11.Customers, [updatedCustomer]));
                }
            }, model.Groups)), Cmd_none()];
        }
        case 11: {
            const updated_3 = msg.fields[0];
            const withMembers = groupWithMembers(updated_3);
            return [new Model(model.SearchTerm, model.GroupsFetched, withMembers.Enabled ? map_1((existing) => {
                if (existing.Id === updated_3.Id) {
                    return withMembers;
                }
                else {
                    return existing;
                }
            }, model.Groups) : model.Groups.filter((existing_1) => (existing_1.Id !== withMembers.Id))), Cmd_none()];
        }
        case 12:
            return [model, Cmd_none()];
        default: {
            const newCustomer = msg.fields[0];
            return [new Model(model.SearchTerm, model.GroupsFetched, sortBy((_arg) => _arg.Name, map_1((group) => {
                if (newCustomer.Groups.some((customerGroup) => (customerGroup.Id === group.Id))) {
                    return new CustomerGroupWithMembers(group.Id, group.Name, group.Enabled, group.IsMain, group.IsPtg, group.Favorite, group.Company, append(group.Customers, [newCustomer]));
                }
                else {
                    return group;
                }
            }, model.Groups), {
                Compare: comparePrimitives,
            })), Cmd_none()];
        }
    }
}

export const hierarchyContext = createContext("CompanyHierarchy", Model_get_Empty());

export const dispatchContext = createContext("CompanyHierarchyDispatch", undefined);

/**
 * Downloads all groups, their companies, and their machines for you to consume
 */
export function CompanyHierarchyProvider(companyHierarchyProviderInputProps) {
    const children = companyHierarchyProviderInputProps.children;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    useEffectWithDeps(() => {
        if ((isEmpty(currentUrl) && model_1.GroupsFetched) && !(model_1.Groups.length === 0)) {
            gotoFirstGroup(model_1.Groups);
        }
        return createDisposable(() => {
            console.debug("Dismounting Company hierarchy provider");
        });
    }, [currentUrl]);
    let child_1;
    let child;
    const xs = toList(delay(() => (model_1.GroupsFetched ? singleton_1(children) : singleton_1(MuiHelpers_createElement(Backdrop, [["open", true], ["children", MuiHelpers_createElement(CircularProgress, [])]])))));
    child = react.createElement(react.Fragment, {}, ...xs);
    child_1 = reactApi.createElement(dispatchContext.Provider, {
        value: patternInput[1],
    }, child);
    return reactApi.createElement(hierarchyContext.Provider, {
        value: model_1,
    }, child_1);
}

